import React, { useState } from "react";
import { ReactComponent as IconDelete } from "../../../../assets/icons/icon-delete.svg";
import { useDispatch } from "react-redux";
import { cartListPrice } from "../../../../Redux/Slices/AddToCartSlice";
import { ADD_TO_CART_LIST_DATA, REMOVE_CART_ITEM } from "../../../../Redux/SagaAction/actions";

const CartListData = ({ data }) => {
  const dispatch = useDispatch();
  const [count, setCount] = useState(1);
  const incrementCount = ({ id, count }) => {
    dispatch(cartListPrice({ id, count }));
  };
  const decrementCount = ({ id, dCount }) => {
    dispatch(cartListPrice({ id, dCount }));
  };
  return (
    
    <li key={data?.cartId}>
      <div className="product-profile-group">
        <img src={data?.productImages} alt="product-images" />
        <div className="detail">
          <h6>{data?.productName}</h6>
          <p>{data?.description}</p>
          <p className="text-black">
            Product id: <span>{data?.productSku}</span>
          </p>
          <div className="flex-box">
            <p className="text-black">
              Color :<span> {data?.color} </span>
            </p>
            <p className="text-black">
              Size :<span> {data?.size} </span>
            </p>
             {(data?.availableQty < 5 && data?.availableQty > 0 )? (
              <p className="red-cart-box">{data?.availableQty} Left</p>)
              : data?.availableQty === 0 ? <p className="red-cart-box">Out of stock</p>
              : (data?.availableQty - data?.addCount  <= 5  && data?.availableQty > 0) ? <p className="red-cart-box"> 5 Left</p> : ""
              }
            {/* {((data?.availableQty === 0) || (data?.availableQty - data?.addCount === 0 && data?.addCount !== 1))  &&  (
              <p className="red-cart-box">Out of stock</p>
            )} */}
            {/* {data?.availableQty <= 5 && data?.availableQty !== 0 && (
              <p className="red-cart-box">{data?.availableQty} Left</p>
            )} */}
            {/* {data?.availableQty - data?.addCount  <= 5 && data?.availableQty - data?.addCount  !== 0   && data?.availableQty !== 0 &&   (
              <p className="red-cart-box">{data?.availableQty - data?.addCount} Left</p>
            )} */}
            {/* {data?.availableQty - data?.addCount <= 5 && ((data?.availableQty - data?.addCount) !== 0) && (
              <p className="red-cart-box">{data?.availableQty - data?.addCount} Left</p>
            )} */}
            {/* {(data?.availableQty - data?.addCount) === 0 && (
              <p className="red-cart-box">Out of stock</p>
            )} */}
          </div>
        </div>
      </div>

      <div className="product-profile-right">
        {/* {data?.availableQty !== 0 && (
          <> */}
          <div className="quantity-group">
            <button
              onClick={() => {
                if (data?.addCount > 1) {
                  decrementCount({
                    id: data?.cartId,
                    dCount: data?.addCount,
                  });
                }
              }}
              className="count min"
              type="button"
            ></button>
            
            <input type="text" value={data?.availableQty === 0 ? data?.availableQty : data?.addCount} />
            <button
              onClick={() => {
                if (data?.addCount !== data?.availableQty) {
                  incrementCount({
                    id: data?.cartId,
                    count: data?.availableQty === 0 ? data?.availableQty : data?.addCount,
                  });
                }
                // dispatch(updatedCart({qty :data?.qty, sizeId : data?.sizeId}))
                // incrementCount(data, data?.qty);
                //   setCount(count + 1);
              }}
              className="count max"
              type="button"
            ></button>
          </div>
  
          <div className="price">
            <span className="original-price">
              ₹{data?.sellingPrice * data?.addCount}
            </span>
          </div>
          {/* </>
            )} */}
        <div className="delete">
          <IconDelete
            onClick={() => {
              dispatch({
                type: REMOVE_CART_ITEM,
                payload: {catalogId: data?.catalogId, variantId: data?.variantId, sizeId: data?.sizeId },
                callback:()=> {
                  dispatch({type:ADD_TO_CART_LIST_DATA})
                }
              });
            }}
          />
        </div>
      </div>
    </li>
  );
};

export default CartListData;
